import {
  LegalPracticeRequest,
  Practice,
  PracticeReport,
  PracticeTakedownSummary,
  PracticeUrl,
  PracticeUser,
} from "core/types/practice.types";

export const transformPracticeReport = (data: any): PracticeReport => ({
  id: data?.id,
  createdAt: data?.created_at,
  path: data?.path,
});

// Stato rimozioni derivato (#5): mappa il takedown_summary del backend (snake_case) in camelCase.
export const transformTakedownSummary = (
  data: any
): PracticeTakedownSummary | undefined =>
  data
    ? {
        urlTotal: data?.url_total ?? 0,
        urlRemoved: data?.url_removed ?? 0,
        urlOnline: data?.url_online ?? 0,
        urlPending: data?.url_pending ?? 0,
        domainsTotal: data?.domains_total ?? 0,
        domainsSent: data?.domains_sent ?? 0,
        derivedStatus: data?.derived_status ?? "in_attesa",
        hasTakedown: data?.has_takedown ?? false,
      }
    : undefined;

export const transformPractice = (data: any): Practice => ({
  createdAt: data?.created_at,
  id: data?.id,
  report: transformPracticeReport(data?.report),
  status: data?.status,
  updatedAt: data?.updated_at,
  urls: data?.urls.map((url: any) => transformPracticeUrl(url)),
  user: transformPracticeUser(data?.user),
  takedownSummary: transformTakedownSummary(data?.takedown_summary),
});

export const transformPracticeRequest = (data: any): LegalPracticeRequest => ({
  urlId: data?.url_id,
  userId: data?.user_id,
  requestType: data?.request_type,
  requestId: data?.request_id,
  createdAt: data?.created_at,
});

export const transformPracticeUser = (data: any): PracticeUser => ({
  id: data?.id,
  firstName: data?.firstName,
  lastName: data?.lastName,
  role: data?.role,
  email: data?.email,
  verified: data?.verified,
});

export const transformPracticeUrl = (data: any): PracticeUrl => ({
  domain: data?.domain,
  id: data?.id,
  status: data?.status,
  url: data?.url,
  lastRequest: {
    createdAt: data?.last_request?.created_at,
    type: data?.last_request?.type,
  },
  description: data?.description,
  title: data?.title,
  thumbnail: data?.thumbnail,
});
